var map = {
	"./de": "MukA",
	"./de.json": "MukA",
	"./en": "NL8I",
	"./en.json": "NL8I",
	"./he": "dpmz",
	"./he.json": "dpmz",
	"./pt": "WHaH",
	"./pt.json": "WHaH",
	"./zh": "BZjr",
	"./zh.json": "BZjr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+jqh";